<script>
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  //MDBTabs,
  //MDBTabNav,
  //MDBTabContent,
  //MDBTabItem,
  //MDBTabPane,
  MDBBtn,
} from "mdb-vue-ui-kit";
//import NumInput from "./helpers/NumInput.vue";
//import ToolTip from "./helpers/ToolTip.vue";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/foresters-financial";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

//import LifetimeSliderInput from "@lifetime-gallagher/lifetime-slider-input";

export default {
  name: "DisclaimerPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    //MDBTabs,
    //MDBTabNav,
    //MDBTabContent,
    //MDBTabItem,
    //MDBTabPane,
    MDBBtn,
    //NumInput,
    //ToolTip,
    //LifetimeSliderInput,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      clientConfig,
      activeTabId: "ex1-1",

      
      grossReturn: 0,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0,
      feePercentageOnContributions: 0,
    };
  },

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },

  computed: {
    ...mapGetters([
      "appVersion",
      "debugMode",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",

      "data",
    ]),

    ...mapFields([
      "userDefinedOption",
      "wageInflation",
      "priceInflation",
    ]),

    filteredInvestmentOptions() {
      let options = [];
      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("Fee") === -1 && option.name.indexOf("User") === -1) {
          options.push(option);
        }
      }
      return options.reverse();
    },

    grossReturnMin() {
      let minValue = 1;
      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1 && option.grossReturn < minValue) {
          minValue = option.grossReturn;
        }
      }
      return this.$x100(minValue);
    },

    grossReturnMax() {
      let maxValue = 0;
      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1 && option.grossReturn > maxValue) {
          maxValue = option.grossReturn;
        }
      }
      return this.$x100(maxValue);
    },

    customInvestmentOption() {
      return this.superEngineConfig.InvestmentOptions['custom'];
    },
  },

  methods: {
    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[tabNum],
        calculator_step: "Back",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[tabNum] + 
          ", calculator_step: Back"
        );


      // Pretend this is an onload of the next page
      setTimeout(() => {
        this.$triggerIframeAnalytics({
          event: "calculator",
          calculator_name: "Investment Forecaster",
          calculator_section: this.analyticsPageNames[this.activeTab],
          calculator_step: "Start",
        });

        if (this.debugMode)
          console.log(
            "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
            this.analyticsPageNames[this.activeTab] + 
            ", calculator_step: Start"
          );
      }, 100);
    },

    setCustomValuesFromPreset(event) {
      const selectedInvestmentOption = event.target.options[event.target.options.selectedIndex];
      if (event.target.options.selectedIndex > 0) {
        this.grossReturn = this.$x100(selectedInvestmentOption.getAttribute('data-grossreturn'));
        this.feePercentageOnBalance = this.$x100(selectedInvestmentOption.getAttribute('data-feepercentageonbalance'));
        this.feePercentageOnBalanceCapped = this.$x100(selectedInvestmentOption.getAttribute('data-feepercentageonbalancecapped'));
        this.feePercentageOnContributions = this.$x100(selectedInvestmentOption.getAttribute('data-feepercentageoncontributions'));

        this.customInvestmentOption.feePercentageOnBalanceCappedCap = parseFloat(selectedInvestmentOption.getAttribute('data-feepercentageonbalancecappedcap'));
        this.customInvestmentOption.feeAnnualDollar = parseFloat(selectedInvestmentOption.getAttribute('data-feeannualdollar'));

        this.superEngineConfig.InvestmentOption = Object.keys(this.superEngineConfig.InvestmentOptions).length;
        this.superEngineConfig.InvestmentOptionInRetirement = Object.keys(this.superEngineConfig.InvestmentOptions).length;
        this.superEngineConfig.InvestmentOption_2 = Object.keys(this.superEngineConfig.InvestmentOptions).length;
        this.superEngineConfig.InvestmentOptionInRetirement_2 = Object.keys(this.superEngineConfig.InvestmentOptions).length;

      } else {
        this.superEngineConfig.InvestmentOption = this.data.DefaultInvestmentOption;
        this.superEngineConfig.InvestmentOptionInRetirement = this.data.DefaultInvestmentOptionInRetirement;
        this.superEngineConfig.InvestmentOption_2 = this.data.DefaultInvestmentOption;
        this.superEngineConfig.InvestmentOptionInRetirement_2 = this.data.DefaultInvestmentOptionInRetirement;
      }
    },

    calculateClosestTaxableIncome(grossReturn) {
      let taxableIncome = 1;
      let calculatedMultiplier = 0;

      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1) {
          if (grossReturn <= option.grossReturn) {
            calculatedMultiplier = option.taxableFraction / option.grossReturn;
            taxableIncome = Math.floor((grossReturn * calculatedMultiplier) * 10000) / 10000;
            break;
          }
        }
      }
      return taxableIncome;
    },
  },

  watch: {
    grossReturn(newVal) {
      this.customInvestmentOption.grossReturn = this.$div100(newVal);
      this.customInvestmentOption.taxableFraction = this.calculateClosestTaxableIncome(this.customInvestmentOption.grossReturn);
    },

    feePercentageOnBalance(newVal) {
      this.customInvestmentOption.feePercentageOnBalance = this.$div100(newVal);
    },

    feePercentageOnBalanceCapped(newVal) {
      this.customInvestmentOption.feePercentageOnBalanceCapped = this.$div100(newVal);
    },

    feePercentageOnContributions(newVal) {
      this.customInvestmentOption.feePercentageOnContributions = this.$div100(newVal);
    },
  },
};
</script>

<template>
  <MDBContainer fluid class="p-0">
    <div class="content-section col-md-11 col-lg-10 mx-auto text-center">
      <MDBRow class="p-0">
        <MDBCol class="mx-auto">
          <!-- <MDBTabs v-model="activeTabId">

            <! -- Tabs navs -- >
            <MDBTabNav tabsClasses="disclaimer-nav">
              <MDBTabItem
                v-if="windowWidth >= 992"
                tabId="ex1-1"
                href="ex1-1"
              >
                View disclaimer & assumptions
              </MDBTabItem>

              <MDBTabItem
                v-if="windowWidth < 992"
                tabId="ex1-1"
                href="ex1-1"
              >
                Disclaimer
              </MDBTabItem>

              <MDBTabItem tabId="ex1-2" href="ex1-2">
                Edit assumptions
              </MDBTabItem>
            </MDBTabNav>

            <MDBTabContent>
              <MDBTabPane tabId="ex1-1" class="disclaimer-tab"> -->
                <MDBRow class="mx-0">
                  <MDBCol class="px-0">
                    <div v-html="clientConfig.content.disclaimer.content"></div>
                    <div class="ver text-end pe-2 py-1">
                      v{{ appVersion }}
                    </div>
                  </MDBCol>
                </MDBRow>
              <!-- </MDBTabPane>

              <MDBTabPane tabId="ex1-2">
                <div class="assumptions-wrapper my-4 mx-5">
                  <MDBRow>
                    <MDBCol class="form-group about px-0">
                      <label class="main-label">
                        Wage inflation (p.a.)

                        <ToolTip text="Default results are expressed in today's dollars by allowing for future expected wage inflation each year. Super projections are discounted to present values at this rate. This is intended to reflect both price increases and general standard of living increases. This has the effect of preserving an individual's relative standard of living.">
                          <span class="icon-info"></span>
                        </ToolTip>
                      </label>

                      <MDBRow>
                        <MDBCol sm="7" md="6" lg="5">
                          <NumInput
                            v-model.number.lazy="wageInflation"
                            divClass="mb-3"
                            cssClass="form-control"
                            :options="{
                              precision: { min: 1, max: 2 },
                              currencyDisplay: 'hidden',
                              valueRange: { min: data.wageInflation.min, max: data.wageInflation.max }
                            }"
                            name="wageInflation"
                            label="Percentage"
                            placeholder="Percentage"
                            :addSuffix="true"
                            suffixText="%"
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol class="form-group about px-0">
                      <label class="main-label">
                        Price inflation (p.a.)

                        <ToolTip text="Price inflation (CPI) is assumed to be 2.5% p.a., which is included in the returns.">
                          <span class="icon-info"></span>
                        </ToolTip>
                      </label>

                      <MDBRow>
                        <MDBCol sm="7" md="6" lg="5">
                          <NumInput
                            v-model.number.lazy="priceInflation"
                            divClass="mb-3"
                            cssClass="form-control"
                            :options="{
                              precision: { min: 1, max: 2 },
                              currencyDisplay: 'hidden',
                              valueRange: { min: data.priceInflation.min, max: data.priceInflation.max }
                            }"
                            name="priceInflation"
                            label="Percentage (p.a.)"
                            placeholder="Percentage (p.a.)"
                            :addSuffix="true"
                            suffixText="%"
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol class="form-group about px-0">
                      <label class="main-label">
                        Insurance premium

                        <ToolTip text="Insurance premiums are assumed to be deducted continuously and increase in line with wage inflation of 4% p.a. unless the Wage inflation assumption is updated above.">
                          <span class="icon-info"></span>
                        </ToolTip>
                      </label>

                      <MDBRow>
                        <MDBCol sm="7" md="6" lg="5">
                          <NumInput
                            v-model.number.lazy="superEngineConfig.InsurancePremium"
                            divClass="mb-3"
                            cssClass="form-control"
                            :options="{
                              precision: { min: 0, max: 2 },
                              valueRange: { min: data.insurancePremium.min, max: data.insurancePremium.max }
                            }"
                            name="customInsurancePremium"
                            label="Amount (pa)"
                            placeholder="Amount (pa)"
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol class="form-group about px-0">
                      <label class="section-label">
                        Edit user defined investment option
                      </label>

                      <label class="main-label">
                        Create user defined investment option based on:
                      </label>
                      <MDBRow>
                        <MDBCol sm="7" md="6" lg="5">
                          <div class="form-floating mb-3">
                            <select
                              id="userDefinedOption"
                              name="userDefinedOption"
                              class="form-select form-control"
                              v-model="userDefinedOption"
                              @change="setCustomValuesFromPreset"
                            >
                              <option selected value="">--choose--</option>
                              <option
                                v-for="(option, index) in filteredInvestmentOptions"
                                :key="index"
                                :value="option.id"
                                :data-feeAnnualDollar="option.feeAnnualDollar"
                                :data-feePercentageOnBalance="option.feePercentageOnBalance"
                                :data-feePercentageOnBalanceCapped="option.feePercentageOnBalanceCapped"
                                :data-feePercentageOnBalanceCappedCap="option.feePercentageOnBalanceCappedCap"
                                :data-feePercentageOnContributions="option.feePercentageOnContributions"
                                :data-grossReturn="option.grossReturn"
                                :data-taxableFraction="option.taxableFraction"
                                :data-optionIndex="index"
                              >
                                {{ option.name }}
                              </option>
                            </select>

                            <label
                              for="userDefinedOption"
                              v-if="userDefinedOption != ''"
                            >
                              Option
                            </label>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  <div v-if="userDefinedOption != ''">
                    <MDBRow>
                      <MDBCol class="form-group about px-0">
                        <label class="section-label">
                          Your user defined investment option:
                        </label>

                        <label class="main-label">
                          Retirement return (p.a)

                          <ToolTip text="This is the assumed investment return in retirement.">
                            <span class="icon-info"></span>
                          </ToolTip>
                        </label>

                        <MDBRow>
                          <MDBCol sm="7" md="6" lg="5">
                            <NumInput
                              v-model.number.lazy="grossReturn"
                              divClass="mb-3"
                              cssClass="form-control"
                              :options="{
                                precision: { min: 0, max: 2 },
                                currencyDisplay: 'hidden',
                                valueRange: { min: grossReturnMin, max: grossReturnMax }
                              }"
                              name="grossReturn"
                              label="Percentage"
                              placeholder="Percentage"
                              :addSuffix="true"
                              suffixText="%"
                            />
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <MDBCol class="form-group about px-0">
                        <label class="main-label">
                          Asset based fee (no cap)

                          <ToolTip text="A percentage fee deducted from before-tax investment returns.">
                            <span class="icon-info"></span>
                          </ToolTip>
                        </label>

                        <MDBRow>
                          <MDBCol sm="7" md="6" lg="5">
                            <NumInput
                              v-model.number.lazy="feePercentageOnBalance"
                              divClass="mb-3"
                              cssClass="form-control"
                              :options="{
                                precision: { min: 0, max: 2 },
                                currencyDisplay: 'hidden',
                                valueRange: { min: data.feePercentageOnBalance.min, max: data.feePercentageOnBalance.max }
                              }"
                              name="feePercentageOnBalance"
                              label="Percentage"
                              placeholder="Percentage"
                              :addSuffix="true"
                              suffixText="%"
                            />
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <MDBCol class="form-group about px-0">
                        <label class="main-label">
                          Asset based fee (with cap)

                          <ToolTip text="The asset based fee cap is indexed to wage inflation and based on $0.">
                            <span class="icon-info"></span>
                          </ToolTip>
                        </label>

                        <MDBRow>
                          <MDBCol sm="7" md="6" lg="5">
                            <NumInput
                              v-model.number.lazy="feePercentageOnBalanceCapped"
                              divClass="mb-3"
                              cssClass="form-control"
                              :options="{
                                precision: { min: 0, max: 2 },
                                currencyDisplay: 'hidden',
                                valueRange: { min: data.feePercentageOnBalanceCapped.min, max: data.feePercentageOnBalanceCapped.max }
                              }"
                              name="feePercentageOnBalanceCapped"
                              label="Percentage"
                              placeholder="Percentage"
                              :addSuffix="true"
                              suffixText="%"
                            />
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <MDBCol class="form-group about px-0">
                        <label class="main-label">
                          Asset based fee cap

                          <ToolTip text="Asset-based fee of 0.10% of your account balance deducted monthly, capped at $350 p.a.">
                            <span class="icon-info"></span>
                          </ToolTip>
                        </label>

                        <MDBRow>
                          <MDBCol sm="7" md="6" lg="5">
                            <NumInput
                                v-model.number.lazy="customInvestmentOption.feePercentageOnBalanceCappedCap"
                                divClass="mb-3"
                                cssClass="form-control"
                                :options="{
                                  precision: { min: 0, max: 2 },
                                  valueRange: { min: data.feePercentageOnBalanceCappedCap.min, max: data.feePercentageOnBalanceCappedCap.max }
                                }"
                                name="feePercentageOnBalanceCappedCap"
                                label="Amount"
                                placeholder="Amount"
                              />
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <MDBCol class="form-group about px-0">
                        <label class="main-label">
                          Fee % on contributions

                          <ToolTip text="Replace this text.">
                            <span class="icon-info"></span>
                          </ToolTip>
                        </label>
                        
                        <MDBRow>
                          <MDBCol sm="7" md="6" lg="5">
                            <NumInput
                              v-model.number.lazy="feePercentageOnContributions"
                              divClass="mb-3"
                              cssClass="form-control"
                              :options="{
                                precision: { min: 0, max: 2 },
                                currencyDisplay: 'hidden',
                                valueRange: { min: data.feePercentageOnContributions.min, max: data.feePercentageOnContributions.max }
                              }"
                              name="feePercentageOnContributions"
                              label="Percentage"
                              placeholder="Percentage"
                              :addSuffix="true"
                              suffixText="%"
                            />
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>

                    <MDBRow class="mb-4">
                      <MDBCol class="form-group about px-0">
                        <label class="main-label">
                          Annual admin fee

                          <ToolTip text="Calculated based on current $1.00 weekly admin fee.">
                            <span class="icon-info"></span>
                          </ToolTip>
                        </label>
                        
                        <MDBRow>
                          <MDBCol sm="7" md="6" lg="5">
                            <NumInput
                              v-model.number.lazy="customInvestmentOption.feeAnnualDollar"
                              :options="{
                                precision: { min: 0, max: 2 },
                                valueRange: { min: data.feeAnnualDollar.min, max: data.feeAnnualDollar.max }
                              }"
                              name="feeAnnualDollar"
                              label="Amount"
                              placeholder="Amount"
                            />
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </div>
              </MDBTabPane>
            </MDBTabContent>
          </MDBTabs> -->
        </MDBCol>
      </MDBRow>
    </div>

    <div class="sub-section-header p-0 col-md-11 col-lg-10 mx-auto mt-4">
      <MDBRow>
        <MDBCol md="11" class="mx-0 my-1 pb-4">
          <MDBBtn
            color="primary"
            class="btn btn-primary"
            @click="clickToTab(lastActiveTab)"
            aria-label="Continue button"
          >
            Back to calculator
          </MDBBtn>
        </MDBCol>
      </MDBRow>
    </div>
  </MDBContainer>
</template>
